<aside class="modern-sidebar" #sidebar [class.toggled]="isToggled()">
  <div class="sidebar-container">
    <!-- Search Section -->
    <div class="sidebar-search">
      <div class="search-input-wrapper">
        <i class="fas fa-search search-icon"></i>
        <input 
          type="search" 
          class="search-input" 
          placeholder="Search menu..."
          [(ngModel)]="searchTerm"
          (input)="filterMenu()">
      </div>
      <button class="pin-button" 
              (click)="togglePin()" 
              [class.pinned]="isPinned()"
              title="Pin/Unpin sidebar">
        <i class="fas" [class.fa-thumbtack]="!isPinned()" [class.fa-times]="isPinned()"></i>
      </button>
    </div>

    <!-- Scrollable Content Area -->
    <div class="scrollable-content">
      <!-- Navigation Menu -->
      <nav class="sidebar-nav">
      <div class="nav-section">
        <h6 class="nav-section-title">Main Menu</h6>
        
        <ul class="nav-menu">
          <!-- Dashboard -->
          <li class="nav-item">
            <a 
              routerLink="/admin/dashboard" 
              routerLinkActive="active"
              class="nav-link">
              <div class="nav-icon">
                <i class="fas fa-chart-line"></i>
              </div>
              <span class="nav-text">ড্যাশবোর্ড</span>
            </a>
          </li>

          <!-- Assessment Section -->
          <li class="nav-item dropdown-item" [class.expanded]="assessmentExpanded">
            <a 
              class="nav-link dropdown-toggle"
              (click)="toggleAssessmentMenu()">
              <div class="nav-icon">
                <i class="fas fa-clipboard-list"></i>
              </div>
              <span class="nav-text">এ্যাসেসমেন্ট</span>
              <i class="fas fa-chevron-down dropdown-arrow" 
                 [class.rotated]="assessmentExpanded"></i>
            </a>
            <ul class="sub-menu" [class.show]="assessmentExpanded">
              <li>
                <a routerLink="/admin/assessment-create" routerLinkActive="active" class="sub-nav-link">
                  <i class="fas fa-plus"></i>
                  <span>এ্যাসেসমেন্ট আবেদন</span>
                </a>
              </li>
              <li>
                <a routerLink="/admin/multiple-assessment-create" routerLinkActive="active" class="sub-nav-link">
                  <i class="fas fa-plus-square"></i>
                  <span>একাধিক এ্যাসেসমেন্ট</span>
                </a>
              </li>
              <li>
                <a routerLink="/admin/assessment-page" routerLinkActive="active" class="sub-nav-link">
                  <i class="fas fa-file-alt"></i>
                  <span>নতুন এ্যাসেসমেন্ট পৃষ্ঠা</span>
                </a>
              </li>
            </ul>
          </li>

          <!-- Print Services -->
          <!-- <li class="nav-item dropdown-item" [class.expanded]="printExpanded">
            <a 
              class="nav-link dropdown-toggle"
              (click)="togglePrintMenu()">
              <div class="nav-icon">
                <i class="fas fa-print"></i>
              </div>
              <span class="nav-text">প্রিন্ট সেবা</span>
              <i class="fas fa-chevron-down dropdown-arrow" 
                 [class.rotated]="printExpanded"></i>
            </a>
            <ul class="sub-menu" [class.show]="printExpanded">
              <li>
                <a routerLink="/admin/assessment-print" routerLinkActive="active" class="sub-nav-link">
                  <i class="fas fa-file-pdf"></i>
                  <span>এ্যাসেসমেন্ট প্রিন্ট</span>
                </a>
              </li>
              <li>
                <a routerLink="/admin/holding-card-print" routerLinkActive="active" class="sub-nav-link">
                  <i class="fas fa-id-card"></i>
                  <span>হোল্ডিং কার্ড প্রিন্ট</span>
                </a>
              </li>
              <li>
                <a routerLink="/admin/up-card-print" routerLinkActive="active" class="sub-nav-link">
                  <i class="fas fa-credit-card"></i>
                  <span>ইউপি স্মার্ট কার্ড প্রিন্ট</span>
                </a>
              </li>
            </ul>
          </li> -->

          <!-- Tax Collection -->
          <li class="nav-item dropdown-item" [class.expanded]="taxExpanded">
            <a 
              class="nav-link dropdown-toggle"
              (click)="toggleTaxMenu()">
              <div class="nav-icon">
                <i class="fas fa-money-bill-wave"></i>
              </div>
              <span class="nav-text">কর আদায়</span>
              <i class="fas fa-chevron-down dropdown-arrow" 
                 [class.rotated]="taxExpanded"></i>
            </a>
            <ul class="sub-menu" [class.show]="taxExpanded">
              <li>
                <a routerLink="/admin/tax-collection-list" routerLinkActive="active" class="sub-nav-link">
                  <i class="fas fa-list-alt"></i>
                  <span>কর আদায় তালিকা</span>
                </a>
              </li>
              <li>
                <a routerLink="/admin/bulk-tax-collection" routerLinkActive="active" class="sub-nav-link">
                  <i class="fas fa-file-excel"></i>
                  <span>বাল্ক ট্যাক্স কালেকশন</span>
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </div>

      <!-- Management Section -->
      <div class="nav-section">
        <h6 class="nav-section-title">Management</h6>
        
        <ul class="nav-menu">
          <!-- Ward Management -->
          <li class="nav-item">
            <a 
              routerLink="/admin/ward-manage" 
              routerLinkActive="active"
              class="nav-link">
              <div class="nav-icon">
                <i class="fas fa-cogs"></i>
              </div>
              <span class="nav-text">ওয়ার্ড ম্যানেজ</span>
            </a>
          </li>

          <!-- Union Management -->
          <li class="nav-item">
            <a 
              routerLink="/admin/union-manage" 
              routerLinkActive="active"
              class="nav-link">
              <div class="nav-icon">
                <i class="fas fa-building"></i>
              </div>
              <span class="nav-text">ইউনিয়ন ম্যানেজ</span>
            </a>
          </li>

          <!-- Unions List (Super Admin Only) -->
          <li class="nav-item" *ngIf="roleService.isSuperAdmin()">
            <a 
              routerLink="/admin/unions-list" 
              routerLinkActive="active"
              class="nav-link">
              <div class="nav-icon">
                <i class="fas fa-list-ul"></i>
              </div>
              <span class="nav-text">সব ইউনিয়ন দেখুন</span>
            </a>
          </li>

          <!-- SMS Service -->
          <li class="nav-item">
            <a 
              routerLink="/admin/quick-sms-service" 
              routerLinkActive="active"
              class="nav-link">
              <div class="nav-icon">
                <i class="fas fa-sms"></i>
              </div>
              <span class="nav-text">এসএমএস সেবা</span>
            </a>
          </li>

          <!-- User Management (Manager/Admin only) -->
          <li class="nav-item" *ngIf="isManager || isSuperAdmin">
            <a 
              routerLink="/admin/user-management" 
              routerLinkActive="active"
              class="nav-link">
              <div class="nav-icon">
                <i class="fas fa-users-cog"></i>
              </div>
              <span class="nav-text">ইউজার ম্যানেজমেন্ট</span>
            </a>
          </li>

          <!-- Image Upload (Super Admin only) -->
          <li class="nav-item" *ngIf="isSuperAdmin">
            <a 
              routerLink="/admin/image-upload" 
              routerLinkActive="active"
              class="nav-link">
              <div class="nav-icon">
                <i class="fas fa-upload"></i>
              </div>
              <span class="nav-text">ইমেজ আপলোড</span>
            </a>
          </li>
        </ul>
      </div>
    </nav>
    </div>

    <!-- Sidebar Footer -->
    <div class="sidebar-footer">
      <div class="footer-content">
        <!-- Main Brand Section -->
        <div class="brand-section">
          <div class="brand-identity">
            <div class="brand-logo">
              <i class="fas fa-building"></i>
            </div>
            <div class="brand-info">
              <h6 class="brand-name">Digital Union</h6>
              <p class="brand-tagline">SaaS Platform</p>
            </div>
          </div>
          <div class="brand-actions">
            <a href="https://digitalunion.softwaveinnovation.com" 
               target="_blank" 
               class="website-btn"
               title="Visit Website">
              <i class="fas fa-external-link-alt"></i>
            </a>
          </div>
        </div>

        <!-- Service Info -->
        <div class="service-info">
          <div class="service-stats">
            <div class="stat-item">
              <span class="stat-label">Version</span>
              <span class="stat-value">2.0</span>
            </div>
            <div class="stat-item">
              <span class="stat-label">Build</span>
              <span class="stat-value">Latest</span>
            </div>
          </div>
          
          <div class="social-section">
            <span class="social-label">Connect</span>
            <div class="social-links">
              <a href="https://www.facebook.com/softwaveinnovation/" 
                 target="_blank" 
                 class="social-link facebook"
                 title="Facebook">
                <i class="fab fa-facebook-f"></i>
              </a>
              <a href="mailto:softwaveinnovation24@gmail.com" 
                 target="_blank" 
                 class="social-link email"
                 title="Email">
                <i class="fas fa-envelope"></i>
              </a>
            </div>
          </div>
        </div>

        <!-- Footer Credits -->
        <div class="footer-credits">
          <p class="copyright">&copy; 2024 Digital Union</p>
          <p class="developer">by <a href="https://softwaveinnovation.com/" target="_blank" class="developer-link">Softwave Innovation</a></p>
        </div>
      </div>
    </div>
  </div>
  
  <!-- Resize Handle -->
  <div class="resize-handle" 
       (mousedown)="onResizeStart($event)"
       title="Drag to resize sidebar">
  </div>
</aside>